export function useSetSafeStorage(key: string, value: string | null | undefined) {
  if(process.client) {
      const cookieRef = useCookie<string | null>(key, {
        sameSite: 'lax',
        secure: true,
        path: '/',
      })

      if (value === null || value === undefined || value === 'null' || value === 'undefined') {
          localStorage.removeItem(key)
          cookieRef.value = null
      } else {
          localStorage.setItem(key, value)

          if (cookieRef.value !== value) {
              cookieRef.value = value
          }
      }

      if (key === 'access_token' && value && value !== 'null' && value !== 'undefined') {
        const currentSlug = localStorage.getItem('_slug');
        if (currentSlug) {
          useSetSafeStorage('auth_restaurant_slug', currentSlug);
        }
      }
  }
}